import { render, staticRenderFns } from "./CollapseCard.vue?vue&type=template&id=a2af10c0&scoped=true&"
import script from "./CollapseCard.vue?vue&type=script&lang=js&"
export * from "./CollapseCard.vue?vue&type=script&lang=js&"
import style0 from "./CollapseCard.vue?vue&type=style&index=0&id=a2af10c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2af10c0",
  null
  
)

export default component.exports